// src/pages/Invoices.jsx
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { supabase } from "../lib/supabaseClient";
import { useAuth } from "../context/AuthContext";

export default function Invoices() {
  const { t } = useTranslation();
  const { user, loading: authLoading } = useAuth();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    const run = async () => {
      try {
        // RLS protège déjà par user_id = auth.uid(); on filtre quand même par sécurité
        const { data, error } = await supabase
          .from("invoices")
          .select("*")
          .eq("user_id", user.id)
          .order("created_at", { ascending: false });

        if (error) throw error;
        setInvoices(data || []);
      } catch (e) {
        console.error("Invoices load error:", e);
        setErr(t("invoicesPage.error"));
      } finally {
        setLoading(false);
      }
    };

    if (user) run();
  }, [user, t]);

  if (authLoading) {
    return <div className="container" style={{ padding: "2rem" }}>{t("invoicesPage.loading")}</div>;
  }

  if (!user) {
    return (
      <div className="container" style={{ padding: "2rem" }}>
        {t("invoicesPage.loginPrompt")}
      </div>
    );
  }

  return (
    <div className="container" style={{ maxWidth: 960, margin: "0 auto", padding: "2rem" }}>
      <h1 style={{ fontSize: 24, fontWeight: 600, marginBottom: 12 }}>{t("invoicesPage.title")}</h1>

      <div style={{ marginBottom: 16, padding: "12px 14px", border: "1px solid #d8cfbd", background: "#faf7f0", borderRadius: 10, fontSize: 13, color: "#5a5343", lineHeight: 1.55 }}>
        {t("invoicesPage.facturxNote")}
      </div>

      {err && (
        <div style={{ marginBottom: 12, padding: 12, border: "1px solid #f5c2c7", background: "#f8d7da", borderRadius: 8, color: "#842029" }}>
          {err}
        </div>
      )}

      <div style={{ overflowX: "auto", borderRadius: 12, border: "1px solid #eee" }}>
        <table style={{ width: "100%", fontSize: 14 }}>
          <thead style={{ background: "#fafafa" }}>
            <tr>
              <th style={{ textAlign: "left", padding: "10px 12px" }}>{t("invoicesPage.colNumber")}</th>
              <th style={{ textAlign: "left", padding: "10px 12px" }}>{t("invoicesPage.colStatus")}</th>
              <th style={{ textAlign: "right", padding: "10px 12px" }}>{t("invoicesPage.colAmount")}</th>
              <th style={{ textAlign: "left", padding: "10px 12px" }}>{t("invoicesPage.colReceipt")}</th>
              <th style={{ textAlign: "left", padding: "10px 12px" }}>{t("invoicesPage.colDetail")}</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5} style={{ padding: 24, textAlign: "center", opacity: 0.7 }}>
                  {t("invoicesPage.loading")}
                </td>
              </tr>
            ) : invoices.length === 0 ? (
              <tr>
                <td colSpan={5} style={{ padding: 24, textAlign: "center", opacity: 0.7 }}>
                  {t("invoicesPage.empty")}
                </td>
              </tr>
            ) : (
              invoices.map((inv) => (
                <tr key={inv.stripe_invoice_id} style={{ borderTop: "1px solid #eee" }}>
                  <td style={{ padding: "10px 12px" }}>{inv.number || inv.stripe_invoice_id}</td>
                  <td style={{ padding: "10px 12px", textTransform: "capitalize" }}>{inv.status}</td>
                  <td style={{ padding: "10px 12px", textAlign: "right" }}>
                    {(((inv.amount_paid ?? inv.amount_due) || 0) / 100).toFixed(2)} {(inv.currency || "eur").toUpperCase()}
                  </td>
                  <td style={{ padding: "10px 12px" }}>
                    {inv.invoice_pdf && (
                      <a href={inv.invoice_pdf} target="_blank" rel="noreferrer">
                        {t("invoicesPage.download")}
                      </a>
                    )}
                  </td>
                  <td style={{ padding: "10px 12px" }}>
                    {inv.hosted_invoice_url && (
                      <a href={inv.hosted_invoice_url} target="_blank" rel="noreferrer">
                        {t("invoicesPage.view")}
                      </a>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
